
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1126"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1126"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9DUBZ", function(module, exports) {

$parcel$export(module.exports, "typeWriter", () => $01cfcd1698ded080$export$245947e8fe008c97);
function $01cfcd1698ded080$export$245947e8fe008c97(element, text, speed = 100) {
    let i = 0;
    function type() {
        if (i < text.length) {
            element.innerHTML += text.charAt(i);
            i++;
            setTimeout(type, speed);
        }
    }
    type();
}

});

parcelRegister("6TaBW", function(module, exports) {

$parcel$export(module.exports, "countryCodes", () => $50401c43f41e65e3$export$7bc41e2d36612b98);
const $50401c43f41e65e3$export$7bc41e2d36612b98 = [
    {
        name: "Afghanistan",
        code: "+93"
    },
    {
        name: "Albania",
        code: "+355"
    },
    {
        name: "Algeria",
        code: "+213"
    },
    {
        name: "Andorra",
        code: "+376"
    },
    {
        name: "Angola",
        code: "+244"
    },
    {
        name: "Argentina",
        code: "+54"
    },
    {
        name: "Armenia",
        code: "+374"
    },
    {
        name: "Australia",
        code: "+61"
    },
    {
        name: "Austria",
        code: "+43"
    },
    {
        name: "Azerbaijan",
        code: "+994"
    },
    {
        name: "Bahamas",
        code: "+1-242"
    },
    {
        name: "Bahrain",
        code: "+973"
    },
    {
        name: "Bangladesh",
        code: "+880"
    },
    {
        name: "Barbados",
        code: "+1-246"
    },
    {
        name: "Belarus",
        code: "+375"
    },
    {
        name: "Belgium",
        code: "+32"
    },
    {
        name: "Belize",
        code: "+501"
    },
    {
        name: "Benin",
        code: "+229"
    },
    {
        name: "Bhutan",
        code: "+975"
    },
    {
        name: "Bolivia",
        code: "+591"
    },
    {
        name: "Bosnia and Herzegovina",
        code: "+387"
    },
    {
        name: "Botswana",
        code: "+267"
    },
    {
        name: "Brazil",
        code: "+55"
    },
    {
        name: "Brunei",
        code: "+673"
    },
    {
        name: "Bulgaria",
        code: "+359"
    },
    {
        name: "Burkina Faso",
        code: "+226"
    },
    {
        name: "Burundi",
        code: "+257"
    },
    {
        name: "Cambodia",
        code: "+855"
    },
    {
        name: "Cameroon",
        code: "+237"
    },
    {
        name: "Canada",
        code: "+1"
    },
    {
        name: "Cape Verde",
        code: "+238"
    },
    {
        name: "Central African Republic",
        code: "+236"
    },
    {
        name: "Chad",
        code: "+235"
    },
    {
        name: "Chile",
        code: "+56"
    },
    {
        name: "China",
        code: "+86"
    },
    {
        name: "Colombia",
        code: "+57"
    },
    {
        name: "Comoros",
        code: "+269"
    },
    {
        name: "Congo (Congo-Brazzaville)",
        code: "+242"
    },
    {
        name: "Costa Rica",
        code: "+506"
    },
    {
        name: "Croatia",
        code: "+385"
    },
    {
        name: "Cuba",
        code: "+53"
    },
    {
        name: "Cyprus",
        code: "+357"
    },
    {
        name: "Czech Republic",
        code: "+420"
    },
    {
        name: "Denmark",
        code: "+45"
    },
    {
        name: "Djibouti",
        code: "+253"
    },
    {
        name: "Dominica",
        code: "+1-767"
    },
    {
        name: "Dominican Republic",
        code: "+1-809"
    },
    {
        name: "Ecuador",
        code: "+593"
    },
    {
        name: "Egypt",
        code: "+20"
    },
    {
        name: "El Salvador",
        code: "+503"
    },
    {
        name: "Equatorial Guinea",
        code: "+240"
    },
    {
        name: "Eritrea",
        code: "+291"
    },
    {
        name: "Estonia",
        code: "+372"
    },
    {
        name: "Eswatini",
        code: "+268"
    },
    {
        name: "Ethiopia",
        code: "+251"
    },
    {
        name: "Fiji",
        code: "+679"
    },
    {
        name: "Finland",
        code: "+358"
    },
    {
        name: "France",
        code: "+33"
    },
    {
        name: "Gabon",
        code: "+241"
    },
    {
        name: "Gambia",
        code: "+220"
    },
    {
        name: "Georgia",
        code: "+995"
    },
    {
        name: "Germany",
        code: "+49"
    },
    {
        name: "Ghana",
        code: "+233"
    },
    {
        name: "Greece",
        code: "+30"
    },
    {
        name: "Grenada",
        code: "+1-473"
    },
    {
        name: "Guatemala",
        code: "+502"
    },
    {
        name: "Guinea",
        code: "+224"
    },
    {
        name: "Guinea-Bissau",
        code: "+245"
    },
    {
        name: "Guyana",
        code: "+592"
    },
    {
        name: "Haiti",
        code: "+509"
    },
    {
        name: "Honduras",
        code: "+504"
    },
    {
        name: "Hungary",
        code: "+36"
    },
    {
        name: "Iceland",
        code: "+354"
    },
    {
        name: "India",
        code: "+91"
    },
    {
        name: "Indonesia",
        code: "+62"
    },
    {
        name: "Iran",
        code: "+98"
    },
    {
        name: "Iraq",
        code: "+964"
    },
    {
        name: "Ireland",
        code: "+353"
    },
    {
        name: "Israel",
        code: "+972"
    },
    {
        name: "Italy",
        code: "+39"
    },
    {
        name: "Jamaica",
        code: "+1-876"
    },
    {
        name: "Japan",
        code: "+81"
    },
    {
        name: "Jordan",
        code: "+962"
    },
    {
        name: "Kazakhstan",
        code: "+7"
    },
    {
        name: "Kenya",
        code: "+254"
    },
    {
        name: "Kiribati",
        code: "+686"
    },
    {
        name: "Kuwait",
        code: "+965"
    },
    {
        name: "Kyrgyzstan",
        code: "+996"
    },
    {
        name: "Laos",
        code: "+856"
    },
    {
        name: "Latvia",
        code: "+371"
    },
    {
        name: "Lebanon",
        code: "+961"
    },
    {
        name: "Lesotho",
        code: "+266"
    },
    {
        name: "Liberia",
        code: "+231"
    },
    {
        name: "Libya",
        code: "+218"
    },
    {
        name: "Liechtenstein",
        code: "+423"
    },
    {
        name: "Lithuania",
        code: "+370"
    },
    {
        name: "Luxembourg",
        code: "+352"
    },
    {
        name: "Madagascar",
        code: "+261"
    },
    {
        name: "Malawi",
        code: "+265"
    },
    {
        name: "Malaysia",
        code: "+60"
    },
    {
        name: "Maldives",
        code: "+960"
    },
    {
        name: "Mali",
        code: "+223"
    },
    {
        name: "Malta",
        code: "+356"
    },
    {
        name: "Mauritania",
        code: "+222"
    },
    {
        name: "Mauritius",
        code: "+230"
    },
    {
        name: "Mexico",
        code: "+52"
    },
    {
        name: "Moldova",
        code: "+373"
    },
    {
        name: "Monaco",
        code: "+377"
    },
    {
        name: "Mongolia",
        code: "+976"
    },
    {
        name: "Montenegro",
        code: "+382"
    },
    {
        name: "Morocco",
        code: "+212"
    },
    {
        name: "Mozambique",
        code: "+258"
    },
    {
        name: "Myanmar",
        code: "+95"
    },
    {
        name: "Namibia",
        code: "+264"
    },
    {
        name: "Nepal",
        code: "+977"
    },
    {
        name: "Netherlands",
        code: "+31"
    },
    {
        name: "New Zealand",
        code: "+64"
    },
    {
        name: "Nicaragua",
        code: "+505"
    },
    {
        name: "Niger",
        code: "+227"
    },
    {
        name: "Nigeria",
        code: "+234"
    },
    {
        name: "North Korea",
        code: "+850"
    },
    {
        name: "North Macedonia",
        code: "+389"
    },
    {
        name: "Norway",
        code: "+47"
    },
    {
        name: "Oman",
        code: "+968"
    },
    {
        name: "Pakistan",
        code: "+92"
    },
    {
        name: "Palau",
        code: "+680"
    },
    {
        name: "Panama",
        code: "+507"
    },
    {
        name: "Papua New Guinea",
        code: "+675"
    },
    {
        name: "Paraguay",
        code: "+595"
    },
    {
        name: "Peru",
        code: "+51"
    },
    {
        name: "Philippines",
        code: "+63"
    },
    {
        name: "Poland",
        code: "+48"
    },
    {
        name: "Portugal",
        code: "+351"
    },
    {
        name: "Qatar",
        code: "+974"
    },
    {
        name: "Romania",
        code: "+40"
    },
    {
        name: "Russia",
        code: "+7"
    },
    {
        name: "Rwanda",
        code: "+250"
    },
    {
        name: "Saint Kitts and Nevis",
        code: "+1-869"
    },
    {
        name: "Saint Lucia",
        code: "+1-758"
    },
    {
        name: "Saint Vincent and the Grenadines",
        code: "+1-784"
    },
    {
        name: "Samoa",
        code: "+685"
    },
    {
        name: "San Marino",
        code: "+378"
    },
    {
        name: "Saudi Arabia",
        code: "+966"
    },
    {
        name: "Senegal",
        code: "+221"
    },
    {
        name: "Serbia",
        code: "+381"
    },
    {
        name: "Seychelles",
        code: "+248"
    },
    {
        name: "Sierra Leone",
        code: "+232"
    },
    {
        name: "Singapore",
        code: "+65"
    },
    {
        name: "Slovakia",
        code: "+421"
    },
    {
        name: "Slovenia",
        code: "+386"
    },
    {
        name: "Solomon Islands",
        code: "+677"
    },
    {
        name: "Somalia",
        code: "+252"
    },
    {
        name: "South Africa",
        code: "+27"
    },
    {
        name: "South Korea",
        code: "+82"
    },
    {
        name: "South Sudan",
        code: "+211"
    },
    {
        name: "Spain",
        code: "+34"
    },
    {
        name: "Sri Lanka",
        code: "+94"
    },
    {
        name: "Sudan",
        code: "+249"
    },
    {
        name: "Suriname",
        code: "+597"
    },
    {
        name: "Sweden",
        code: "+46"
    },
    {
        name: "Switzerland",
        code: "+41"
    },
    {
        name: "Syria",
        code: "+963"
    },
    {
        name: "Taiwan",
        code: "+886"
    },
    {
        name: "Tajikistan",
        code: "+992"
    },
    {
        name: "Tanzania",
        code: "+255"
    },
    {
        name: "Thailand",
        code: "+66"
    },
    {
        name: "Togo",
        code: "+228"
    },
    {
        name: "Tonga",
        code: "+676"
    },
    {
        name: "Trinidad and Tobago",
        code: "+1-868"
    },
    {
        name: "Tunisia",
        code: "+216"
    },
    {
        name: "Turkey",
        code: "+90"
    },
    {
        name: "Turkmenistan",
        code: "+993"
    },
    {
        name: "Uganda",
        code: "+256"
    },
    {
        name: "Ukraine",
        code: "+380"
    },
    {
        name: "United Arab Emirates",
        code: "+971"
    },
    {
        name: "United Kingdom",
        code: "+44"
    },
    {
        name: "United States",
        code: "+1"
    },
    {
        name: "Uruguay",
        code: "+598"
    },
    {
        name: "Uzbekistan",
        code: "+998"
    },
    {
        name: "Vanuatu",
        code: "+678"
    },
    {
        name: "Vatican City",
        code: "+379"
    },
    {
        name: "Venezuela",
        code: "+58"
    },
    {
        name: "Vietnam",
        code: "+84"
    },
    {
        name: "Yemen",
        code: "+967"
    },
    {
        name: "Zambia",
        code: "+260"
    },
    {
        name: "Zimbabwe",
        code: "+263"
    }
];

});


var $9DUBZ = parcelRequire("9DUBZ");

var $6TaBW = parcelRequire("6TaBW");

var $cP3LP = parcelRequire("cP3LP");
document.addEventListener("DOMContentLoaded", ()=>{
    const requestOtpForm = document.getElementById("request-otp-form");
    const verifyOtpForm = document.getElementById("verify-otp-form");
    const resetPasswordForm = document.getElementById("reset-password-form");
    const identifierTypeDropdown = document.getElementById("identifier-type-dropdown");
    const identifierInput = document.getElementById("identifier");
    const phoneInputContainer = document.getElementById("phone-input-container");
    const phoneInput = document.getElementById("phone");
    const phoneNumberError = document.getElementById("phone-number-error");
    const otpInput = document.getElementById("otp-input");
    const resendOtpBtn = document.getElementById("resend-otp-btn");
    const newPasswordInput = document.getElementById("new-password");
    const confirmPasswordInput = document.getElementById("confirm-password");
    let globalIdentifier = "";
    let globalIdentifierType = "username"; // Default
    let globalCountryCode = "+91"; // Default
    // --- Utility Functions ---
    function validatePhoneNumber() {
        const currentPhone = phoneInput.value.trim();
        phoneNumberError.textContent = ""; // Clear previous errors
        const phoneRegex = /^\d*$/; // Only allow digits
        if (!phoneRegex.test(currentPhone)) {
            phoneNumberError.textContent = "Phone number must contain only digits.";
            phoneInput.setCustomValidity("Phone number must contain only digits.");
        } else phoneInput.setCustomValidity("");
    }
    // --- Country Code Dropdown Population ---
    const countryCodeDropdownOptions = document.querySelector("#phoneInputContainer #countryCodeDropdown .dropdown-options");
    const selectedCountryCodeSpan = document.querySelector("#phoneInputContainer #selectedCountryCode");
    const hiddenCountryCodeInput = document.querySelector("#phoneInputContainer #countryCode");
    if (countryCodeDropdownOptions && typeof (0, $6TaBW.countryCodes) !== "undefined") {
        (0, $6TaBW.countryCodes).forEach((country)=>{
            const a = document.createElement("a");
            a.href = "#";
            a.setAttribute("data-value", country.code);
            a.textContent = `${country.code} (${country.name})`;
            countryCodeDropdownOptions.appendChild(a);
        });
        // Set initial selected value (e.g., India +91)
        const defaultCountry = (0, $6TaBW.countryCodes).find((country)=>country.code === "+91");
        if (defaultCountry) {
            selectedCountryCodeSpan.textContent = `${defaultCountry.code} (${defaultCountry.name})`;
            hiddenCountryCodeInput.value = defaultCountry.code;
            globalCountryCode = defaultCountry.code;
        }
    }
    // --- Event Listeners ---
    if (phoneInput) phoneInput.addEventListener("input", validatePhoneNumber);
    const countryCodeDropdown = document.getElementById("countryCodeDropdown");
    if (countryCodeDropdown) countryCodeDropdown.addEventListener("dropdown-change", (e)=>{
        globalCountryCode = e.detail.value;
        if (globalIdentifierType === "phone") validatePhoneNumber();
    });
    identifierTypeDropdown.addEventListener("dropdown-change", (e)=>{
        globalIdentifierType = e.detail.value;
        if (globalIdentifierType === "phone") {
            phoneInputContainer.style.display = "flex";
            identifierInput.style.display = "none";
            identifierInput.required = false;
            phoneInput.required = true;
            identifierInput.value = ""; // Clear email/username input
            phoneNumberError.textContent = ""; // Clear phone error
        } else {
            // Covers 'username' and 'email'
            phoneInputContainer.style.display = "none";
            identifierInput.style.display = "block";
            identifierInput.required = true;
            phoneInput.required = false;
            identifierInput.placeholder = `Enter your ${globalIdentifierType}`;
            phoneInput.value = ""; // Clear phone input
            phoneNumberError.textContent = ""; // Clear phone error
        }
    });
    // --- Step 1: Request OTP Form Submission ---
    if (requestOtpForm) requestOtpForm.addEventListener("submit", async (event)=>{
        event.preventDefault();
        if (globalIdentifierType === "phone") {
            validatePhoneNumber();
            if (phoneInput.checkValidity() === false) {
                (0, $cP3LP.showToast)(phoneNumberError.textContent, "error");
                return;
            }
            globalIdentifier = globalCountryCode + phoneInput.value;
        } else if (globalIdentifierType === "username") globalIdentifier = identifierInput.value;
        else globalIdentifier = identifierInput.value;
        // Basic validation
        if (!globalIdentifier) {
            (0, $cP3LP.showToast)("Please enter your identifier.", "error");
            return;
        }
        (0, $cP3LP.showGlobalPreloader)("Sending OTP...");
        try {
            const response = await fetch("/api/auth/forgot-password/request-otp", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    identifier: globalIdentifier,
                    identifier_type: globalIdentifierType
                })
            });
            const data = await response.json();
            if (response.ok) {
                (0, $cP3LP.showToast)(data.message, "success");
                requestOtpForm.style.display = "none";
                verifyOtpForm.style.display = "block";
            } else (0, $cP3LP.showToast)(data.error || "Failed to send OTP.", "error");
        } catch  {
            (0, $cP3LP.showToast)("Network error. Please try again.", "error");
        } finally{
            (0, $cP3LP.hideGlobalPreloader)();
        }
    });
    // --- Step 2: Verify OTP Form Submission ---
    if (verifyOtpForm) verifyOtpForm.addEventListener("submit", async (event)=>{
        event.preventDefault();
        const otp = otpInput.value;
        if (!otp || otp.length !== 4) {
            (0, $cP3LP.showToast)("Please enter a 4-digit OTP.", "error");
            return;
        }
        (0, $cP3LP.showGlobalPreloader)("Verifying OTP...");
        try {
            const response = await fetch("/api/auth/forgot-password/verify-otp", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    identifier: globalIdentifier,
                    identifier_type: globalIdentifierType,
                    otp: otp
                })
            });
            const data = await response.json();
            if (response.ok) {
                (0, $cP3LP.showToast)(data.message, "success");
                verifyOtpForm.style.display = "none";
                resetPasswordForm.style.display = "block";
            } else (0, $cP3LP.showToast)(data.error || "OTP verification failed.", "error");
        } catch  {
            (0, $cP3LP.showToast)("Network error. Please try again.", "error");
        } finally{
            (0, $cP3LP.hideGlobalPreloader)();
        }
    });
    // --- Resend OTP Button ---
    if (resendOtpBtn) resendOtpBtn.addEventListener("click", async ()=>{
        (0, $cP3LP.showGlobalPreloader)("Resending OTP...");
        try {
            const response = await fetch("/api/auth/forgot-password/request-otp", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    identifier: globalIdentifier,
                    identifier_type: globalIdentifierType
                })
            });
            const data = await response.json();
            if (response.ok) (0, $cP3LP.showToast)(data.message, "success");
            else (0, $cP3LP.showToast)(data.error || "Failed to resend OTP.", "error");
        } catch  {
            (0, $cP3LP.showToast)("Network error. Please try again.", "error");
        } finally{
            (0, $cP3LP.hideGlobalPreloader)();
        }
    });
    // --- Step 3: Reset Password Form Submission ---
    if (resetPasswordForm) resetPasswordForm.addEventListener("submit", async (event)=>{
        event.preventDefault();
        const newPassword = newPasswordInput.value;
        const confirmPassword = confirmPasswordInput.value;
        if (newPassword !== confirmPassword) {
            (0, $cP3LP.showToast)("Passwords do not match.", "error");
            return;
        }
        if (newPassword.length < 6) {
            // Basic password length check
            (0, $cP3LP.showToast)("Password must be at least 6 characters long.", "error");
            return;
        }
        (0, $cP3LP.showGlobalPreloader)("Resetting Password...");
        try {
            const response = await fetch("/api/auth/forgot-password/reset", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    identifier: globalIdentifier,
                    identifier_type: globalIdentifierType,
                    new_password: newPassword
                })
            });
            const data = await response.json();
            if (response.ok) {
                (0, $cP3LP.showToast)(data.message, "success");
                setTimeout(()=>{
                    window.location.href = "/login"; // Redirect to login page
                }, 2000);
            } else (0, $cP3LP.showToast)(data.error || "Failed to reset password.", "error");
        } catch  {
            (0, $cP3LP.showToast)("Network error. Please try again.", "error");
        } finally{
            (0, $cP3LP.hideGlobalPreloader)();
        }
    });
    // Initialize typing effect
    const typingHeading = document.getElementById("typing-heading");
    if (typingHeading) (0, $9DUBZ.typeWriter)(typingHeading, "Reset Your Password");
});


//# sourceMappingURL=forgot_password.4d5e074e.js.map
